import { NzModalService, NzModalRef } from "ng-zorro-antd";
import { CommonService } from 'fccore2';
import { FcEvent } from "./fcevent.event";
import { TemplateRef, Type } from "@angular/core";
import { FcmodalinputComponent } from "../fcmodal/fcmodalinput.component";
import { Subscription } from "rxjs";
export class FcmodalBusiness {
    static modalService: NzModalService = undefined;
    //å¯¹è¯æ¡å¼ç¨
    static modalRef: NzModalRef = undefined;
    static init(modalService: NzModalService): Subscription[] {
        FcmodalBusiness.modalService = modalService;
        return [
            /**æ®éæ¨¡å¼å¼¹çª,åå®¹æ¯æå­ç¬¦åæ¨¡æ¿*/
            CommonService.subscribe(FcEvent.fcmodal.dialog, (result) => {
                this.open(result.param);
            }),
            /**è¯¢é®æ¡*/
            CommonService.subscribe(FcEvent.fcmodal.confirm, (result) => {
                this.confirm(result.param);
            }),
            /**æå*/
            CommonService.subscribe(FcEvent.fcmodal.success, (result) => {
                this.success(result.param);
            }),
            /**éè¯¯*/
            CommonService.subscribe(FcEvent.fcmodal.error, (result) => {
                this.error(result.param);
            }),
            /**æç¤º*/
            CommonService.subscribe(FcEvent.fcmodal.info, (result) => {
                this.info(result.param);
            }),
            /**è­¦å*/
            CommonService.subscribe(FcEvent.fcmodal.warning, (result) => {
                this.warning(result.param);
            }),
            /**è¾å¥å¼¹çª*/
            CommonService.subscribe(FcEvent.fcmodal.input, (result) => {
                this.input(result.param, result.param.input);
            }),
            /**ç»ä»¶å¼¹çª*/
            CommonService.subscribe(FcEvent.fcmodal.component, (result) => {
                this.component(result.param, result.param);
            })]
    }
    /**
     * æ®éæ¨¡å¼å¼¹çª
     * @param modalConfig 
     */
    private static open(modalConfig: FcModalConfig):NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        let modal = this.modalService.create({
            nzTitle: modalConfig.title,
            nzContent: modalConfig.content,
            nzClosable: modalConfig.closable || true,
            nzOnOk: () => modalConfig.okFunc(),
            nzOnCancel: () => modalConfig.cancelFunc(),
            nzComponentParams: modalConfig.componentParams,
            nzVisible: modalConfig.visible,
            nzZIndex: modalConfig.zIndex,
            nzWidth: modalConfig.width,
            nzWrapClassName: modalConfig.wrapClassName,
            nzClassName: modalConfig.className,
            nzStyle: modalConfig.style,
            nzIconType: modalConfig.iconType,
            nzMask: modalConfig.mask,
            nzMaskClosable: modalConfig.maskClosable || false,
            nzMaskStyle: modalConfig.maskStyle,
            nzBodyStyle: modalConfig.bodyStyle,
            nzFooter: modalConfig.footer,
            nzGetContainer: modalConfig.getContainer,
            nzOkText: modalConfig.okText || 'ç¡®å®',
            nzOkType: modalConfig.okType,
            nzOkLoading: modalConfig.okLoading,
            nzCancelText: modalConfig.cancelText || 'åæ¶',
            nzCancelLoading: modalConfig.cancelLoading
        });
        modal.afterClose.subscribe(result => {
            CommonService.event(modalConfig.token, result);
        })
        return modal;
    }
    /**
     * è¯¢é®æ¡
     * @param modalConfig 
     */
    private static confirm(modalConfig: FcModalConfig): NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        return this.modalService.confirm({
            nzTitle: modalConfig.title,
            nzContent: modalConfig.content,
            nzWidth: modalConfig.width || '416',
            nzOkText: modalConfig.okText || 'ç¡®å®',
            nzCancelText: modalConfig.cancelText || 'åæ¶',
            nzWrapClassName: modalConfig.wrapClassName,
            nzClassName: modalConfig.className,
            nzStyle: modalConfig.style,
            nzOnOk: () => modalConfig.okFunc(),
            nzOnCancel: () => modalConfig.cancelFunc(),
            nzMaskClosable: true
        });
    }
    /**
     * è¾å¥å¼¹çª
     * @param modalConfig 
     */
    private static input(modalConfig: FcModalConfig, input): NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        /**è¾å¥çåå®¹*/
        let _content: string | number;
        let modal = this.modalService.create({
            nzTitle: modalConfig.title,
            nzWrapClassName: modalConfig.wrapClassName,
            nzClassName: modalConfig.className,
            nzStyle: modalConfig.style,
            nzWidth: modalConfig.width || '416',
            nzContent: FcmodalinputComponent,
            nzClosable: modalConfig.closable || true,
            nzOkText: modalConfig.okText || 'ç¡®å®',
            nzCancelText: modalConfig.cancelText || 'åæ¶',
            nzComponentParams: {
                options: input
            }
        });
        /**
         * 
         */
        modal.afterClose.subscribe(result => {
            CommonService.event(modalConfig.token, result);
        })
        return modal;
    }
    /**
     * æç¤º
     * @param modalConfig 
     */
    private static info(modalConfig: FcModalConfig): NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        let modal = this.modalService.info({
            nzTitle: modalConfig.title,
            nzContent: modalConfig.content,
            nzClosable: modalConfig.closable || true,
            nzWidth: modalConfig.width || '416',
            nzWrapClassName: modalConfig.wrapClassName,
            nzClassName: modalConfig.className,
            nzStyle: modalConfig.style,
            nzOnOk: () => modalConfig.okFunc(),
            nzOnCancel: () => modalConfig.cancelFunc(),
            nzComponentParams: modalConfig.componentParams,
            nzMaskClosable: true,
            nzOkText: modalConfig.okText || 'ç¡®å®'
        });
        modal.afterClose.subscribe(result => {
            CommonService.event(modalConfig.token, result);
        })
        return modal;
    }
    /**
     * æå
     * @param modalConfig 
     */
    private static success(modalConfig: FcModalConfig): NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        let modal = this.modalService.success({
            nzTitle: modalConfig.title,
            nzContent: modalConfig.content,
            nzClosable: true,
            nzMaskClosable: true,
            nzOnOk: () => modalConfig.okFunc(),
            nzWidth: modalConfig.width || '416',
            nzOnCancel: () => modalConfig.cancelFunc(),
            nzWrapClassName: modalConfig.wrapClassName,
            nzClassName: modalConfig.className,
            nzStyle: modalConfig.style,
            nzOkText: modalConfig.okText || 'ç¡®å®',
            nzComponentParams: modalConfig.componentParams
        });
        modal.afterClose.subscribe(result => {
            CommonService.event(modalConfig.token, result);
        })
        return modal;
    }
    /**
     * éè¯¯
     * @param modalConfig 
     */
    private static error(modalConfig: FcModalConfig): NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        let modal = this.modalService.error({
            nzTitle: modalConfig.title,
            nzContent: modalConfig.content,
            nzMaskClosable: false,
            nzWidth: modalConfig.width || '416',
            nzWrapClassName: modalConfig.wrapClassName,
            nzClassName: modalConfig.className,
            nzStyle: modalConfig.style,
            nzOnOk: () => modalConfig.okFunc(),
            nzOnCancel: () => modalConfig.cancelFunc(),
            nzComponentParams: modalConfig.componentParams,
            nzOkText: modalConfig.okText || 'ç¡®å®',
        });
        modal.afterClose.subscribe(result => {
            CommonService.event(modalConfig.token, result);
        })
        return modal;
    }
    /**
     * è­¦å
     * @param modalConfig 
     */
    private static warning(modalConfig: FcModalConfig):NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        let modal = this.modalService.warning({
            nzTitle: modalConfig.title,
            nzContent: modalConfig.content,
            nzClosable: modalConfig.closable || true,
            nzWrapClassName: modalConfig.wrapClassName,
            nzClassName: modalConfig.className,
            nzStyle: modalConfig.style,
            nzMaskClosable: true,
            nzWidth: modalConfig.width || '416',
            nzOnOk: () => modalConfig.okFunc(),
            nzOnCancel: () => modalConfig.cancelFunc(),
            nzComponentParams: modalConfig.componentParams,
            nzOkText: modalConfig.okText || 'ç¡®å®',
        });
        modal.afterClose.subscribe(result => {
            CommonService.event(modalConfig.token, result);
        })
        return modal;
    }
    /**
     * ç»ä»¶
     * @param modalConfig 
     */
    private static component(modalConfig: FcModalConfig, content: TemplateRef<{}>, ):NzModalRef<any> {
        if (!modalConfig.cancelFunc) {
            modalConfig.cancelFunc = () => { };
        }
        if (!modalConfig.okFunc) {
            modalConfig.okFunc = () => { };
        }
        this.modalRef = this.modalService.create({
            nzTitle: modalConfig.title,
            nzContent: modalConfig.content,
            nzClosable: modalConfig.closable || true,
            nzClassName: modalConfig.className,
            nzWidth: modalConfig.width || '80%',
            nzOnOk: () => modalConfig.okFunc(),
            nzOnCancel: () => modalConfig.cancelFunc(),
            nzFooter: modalConfig.footer,
            nzMask:modalConfig.mask===undefined?true:modalConfig.mask,
            nzMaskClosable: modalConfig.maskClosable || false,
            nzComponentParams: modalConfig.componentParams,
            nzOkText: modalConfig.okText || 'ç¡®å®',
            nzCancelText: modalConfig.cancelText || 'åæ¶',
        });
        this.modalRef.afterClose.subscribe(result => {
            //éè¿ NzModalService æå¡æ¹å¼åå»ºçå¯¹è¯æ¡éè¦èªè¡ç®¡çå¶çå½å¨æãæ¯å¦ä½ å¨é¡µé¢è·¯ç±åæ¢æ¶ï¼æå¡æ¹å¼åå»ºçå¯¹è¯æ¡å¹¶ä¸ä¼è¢«éæ¯ï¼ä½ éè¦ä½¿ç¨å¯¹è¯æ¡å¼ç¨æ¥æå¨éæ¯ï¼NzModalRef.close() æ NzModalRef.destroy())ã
            CommonService.event(modalConfig.token + '-afterclose', result);
            this.modalRef.destroy();
        })
        CommonService.subscribe(modalConfig.token + '-close', () => {
            this.modalRef.destroy();
        });
        CommonService.subscribe(modalConfig.token + '-cancel', () => {
            this.modalRef.destroy();
        });
        return this.modalRef;
    }
}

export interface FcModalConfig {
    visible?: boolean;
    zIndex?: number;
    width?: number | string;
    wrapClassName?: string;
    className?: string;
    style?: object;
    iconType?: string;
    componentParams?: object;
    closable?: boolean;
    mask?: boolean;
    maskClosable?: boolean;
    maskStyle?: object;
    bodyStyle?: object;
    getContainer?: HTMLElement;
    okText?: string;
    okType?: string;
    okLoading?: boolean;
    cancelText?: string;
    cancelLoading?: boolean;
    title: string;
    content?: string | TemplateRef<{}> | Type<{}>;
    closeable?: true;
    okFunc?: Function;
    cancelFunc?: Function;
    footer?: any;
    token?: string;
    afterOpen?: Function,
    afterClose?: Function
}
export interface FcModalFooterConfig {
    label: string;  /** æé®ææ¬*/
    type?: string;  /** ç±»å*/
    shape?: string;  /** å½¢ç¶*/
    ghost?: boolean;  /** æ¯å¦ghost*/
    size?: string;  /** å¤§å°*/
    autoLoading?: boolean;  /** é»è®¤ä¸ºtrueï¼è¥ä¸ºtrueæ¶ï¼å½onClickè¿åpromiseæ¶æ­¤æé®å°èªå¨ç½®ä¸ºloadingç¶æ*/
    /** æç¤ºï¼ä¸æ¹æ¹æ³çthisæåè¯¥éç½®å¯¹è±¡èªèº«ãå½nzContentä¸ºç»ä»¶ç±»æ¶ï¼ä¸æ¹æ¹æ³ä¼ å¥çcontentComponentInstanc*/
    /** æ¯å¦æ¾ç¤ºè¯¥æé®*/
    show?: boolean;
    /** æ¯å¦æ¾ç¤ºä¸ºloading*/
    loading?: boolean;
    /** æ¯å¦ç¦ç¨*/
    disabled?: boolean;
    /** æé®ç¹å»åè°*/
    /** onClick?Function;*/
}

